export default "__VITE_ASSET__CK2FVREb__"